import { TaskType } from "../types";
import { isIOS, isIOS13 } from "react-device-detect";

export const getUrl = (type: TaskType, arg: string) => {
  // X (Twitter)
  if (type === TaskType.X_FOLLOW) {
    return `https://x.com/intent/follow?screen_name=${arg}`;
  } else if (type === TaskType.X_LIKE) {
    return `https://x.com/intent/like?tweet_id=${arg?.split("/")[arg.split("/").length - 1]}`;
  } else if (type === TaskType.X_POST) {
    return `https://x.com/intent/tweet?text=${encodeURIComponent(arg)}`;
  } else if (type === TaskType.X_REPOST) {
    return `https://x.com/intent/retweet?tweet_id=${arg?.split("/")[arg.split("/").length - 1]}`;
  } else if (type === TaskType.X_COMMENT) {
    return `https://x.com/intent/post?in_reply_to=${arg?.split("/")[arg.split("/").length - 1]}`;
  }

  // Discord
  if (type === TaskType.DISCORD_JOIN) {
    return `https://discord.gg/${arg}`;
  }

  // Telegram
  if (type === TaskType.TELEGRAM_JOIN) {
    return `https://t.me/${arg}`;
  }

  // EPNS
  if (type === TaskType.EPNS_SUBSCRIPTION) {
    return `https://app.push.org/channels?channel=${arg}`;
  }
};

export const changeQueryParams = (
  searchParam: string,
  pathname: string,
  collectionId: string,
  update: (url: string) => void,
  reset: boolean,
) => {
  if (!reset) {
    const queryParams = new URLSearchParams(searchParam);
    queryParams.set("collectionId", collectionId);
    // queryParams.set('collectionView', isCollectionView)
    // queryParams.set('mintView', isMintView)
    const newUrl = `${pathname}?${queryParams.toString()}`;
    update(newUrl);
  } else {
    update(pathname);
  }
};

export const getTarget = () => {
  if (isIOS || isIOS13) {
    return "_top";
  } else {
    return "_blank";
  }
};
